var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();_vm.sidebar.show = !_vm.sidebar.show}}}),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("app_name")))]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }